import { MedicationInstructionAPI } from './types'

export const medicationInstructionApi: MedicationInstructionAPI = ky => {
  return {
    async fetch({ patientId }) {
      return ky(`patient/${patientId}/medication_instruction/`, {
        method: 'get'
      }).json()
    },

    async fetchOne({ patientId, medicationInstructionId }) {
      return ky(
        `patient/${patientId}/medication_instruction/${medicationInstructionId}/`,
        {
          method: 'get'
        }
      ).json()
    },

    async fetchFile({ patientId }) {
      return ky(`patient/${patientId}/medication_instruction/csv/`, {
        method: 'get'
      }).blob()
    },

    async create({ patientId, payload }) {
      return await ky(`patient/${patientId}/medication_instruction/`, {
        method: 'post',
        body: JSON.stringify(payload)
      }).json()
    },

    async update({ patientId, medicationInstructionId, payload }) {
      return await ky(
        `patient/${patientId}/medication_instruction/${medicationInstructionId}/`,
        {
          method: 'put',
          body: JSON.stringify(payload)
        }
      ).json()
    },

    async patch({ patientId, medicationInstructionId, payload }) {
      return await ky(
        `patient/${patientId}/medication_instruction/${medicationInstructionId}/`,
        {
          method: 'patch',
          body: JSON.stringify(payload)
        }
      ).json()
    },

    async delete({ patientId, medicationInstructionId }) {
      await ky(
        `patient/${patientId}/medication_instruction/${medicationInstructionId}/`,
        {
          method: 'delete'
        }
      )
    }
  }
}
